// extracted by mini-css-extract-plugin
module.exports = {"skip":"skip-link_skip__hUdYQ","target":"skip-link_target__E17Yk"};